(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8102],{

/***/ 86176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Options; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89624);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function Options(props) {
    if (!props.item.descriptionItems) {
        return(// @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: any; className: string; numberOf... Remove this comment to see the full error message
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().options),
            numberOfLines: 30,
            children: props.item.description
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().selectionItems),
        children: props.item.descriptionItems.map(function(item, index1) {
            var title = item.title, selections = item.selections;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().item),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
                        children: title
                    }),
                    selections.map(function(selection, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().selectionText),
                            children: [
                                "- ",
                                selection
                            ]
                        }, index);
                    })
                ]
            }, index1);
        })
    });
};


/***/ }),

/***/ 28102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Content_Item; }
});

// UNUSED EXPORTS: Item

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/analytics/events/index.ts + 3 modules
var events = __webpack_require__(54646);
// EXTERNAL MODULE: ./src/helpers/analytics/sendEvents.ts
var sendEvents = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/hooks/useAnalyticLocation.ts
var useAnalyticLocation = __webpack_require__(78425);
// EXTERNAL MODULE: ./src/hooks/useEventsBaseProperties.ts
var useEventsBaseProperties = __webpack_require__(87037);
// EXTERNAL MODULE: ./src/i18n/formatNumber/index.ts + 1 modules
var formatNumber = __webpack_require__(78263);
// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(82723);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/Item/hooks/useItemBenefits.main.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getItemBenefits($websiteId: ID) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          cart {\n            benefits\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useItemBenefits() {
    var ref;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var preferences = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }).preferences;
    return (preferences === null || preferences === void 0 ? void 0 : (ref = preferences.cart) === null || ref === void 0 ? void 0 : ref.benefits) || [];
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/data/queries/preferences/refetchCart.tsx
var refetchCart = __webpack_require__(71716);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/decorators/withMessage.js
var withMessage = __webpack_require__(77543);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withMutation.js
var withMutation = __webpack_require__(68688);
// EXTERNAL MODULE: ./node_modules/autobind-decorator/lib/esm/index.js
var lib_esm = __webpack_require__(88572);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(96026);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Item/Amount/styles.module.css
var styles_module = __webpack_require__(39236);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/Item/Amount/index.tsx
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function Amount_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

function Amount_templateObject() {
    var data = Amount_taggedTemplateLiteral([
        "\n  mutation updateCartItemAmount($cartItemId: ID, $amount: Float) {\n    updateCartItemAmount(cartItemId: $cartItemId, amount: $amount) {\n      _id\n      amount\n    }\n  }\n"
    ]);
    Amount_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var _class, _dec, _dec1, _dec2, _dec3;
var MAX_SELECT_AMOUNT = 20;
var MORE_SELECT_AMOUNT = MAX_SELECT_AMOUNT + 1;
var _dec4 = (0,withMutation["default"])((0,lib["default"])(Amount_templateObject()));
var Amount = _class = _dec4(_class = (0,withMessage/* default */.Z)(((_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Amount, _Component);
    var _super = _createSuper(Amount);
    function Amount() {
        _classCallCheck(this, Amount);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            inputState: undefined
        };
        return _this;
    }
    var _proto = Amount.prototype;
    _proto.update = function update(amount) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var _props, ref, _props1, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return _this.props.updateCartItemAmount({
                            cartItemId: _this.props.item._id,
                            amount: amount
                        });
                    case 4:
                        (ref = (_props = _this.props).sendEvent) === null || ref === void 0 ? void 0 : ref.call(_props, {
                            cartItemId: _this.props.item._id,
                            amount: amount
                        });
                        _ctx.next = 7;
                        return (ref1 = (_props1 = _this.props).refetchCart) === null || ref1 === void 0 ? void 0 : ref1.call(_props1);
                    case 7:
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        _this.props.showMessage(_ctx.t0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }))();
    };
    _proto.onChange = function onChange(event) {
        var amount = Number(event.target.value);
        this.update(amount);
        this.setState({
            inputState: String(amount)
        });
    };
    _proto.renderOptions = function renderOptions() {
        var maxPurchaseQuantity = get_default()(this.props, "item.product.maxPurchaseQuantity");
        var rangeMax = maxPurchaseQuantity && maxPurchaseQuantity < MORE_SELECT_AMOUNT ? maxPurchaseQuantity : MORE_SELECT_AMOUNT;
        return range_default()(0, rangeMax + 1).map(function(amount) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: String(amount),
                children: amount === MORE_SELECT_AMOUNT ? "M\xe1s" : amount
            }, amount);
        });
    };
    _proto.renderSelect = function renderSelect() {
        var amount = this.props.item.amount;
        if (amount && amount >= MORE_SELECT_AMOUNT) {
            var _this = this;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                value: isString_default()(this.state.inputState) ? this.state.inputState : String(amount),
                onChange: function(event) {
                    return _this.setState({
                        inputState: event.target.value
                    });
                },
                className: (styles_module_default()).biggerInput,
                onBlur: this.onChange
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                className: (styles_module_default()).select,
                onChange: this.onChange,
                value: String(amount),
                children: this.renderOptions()
            })
        });
    };
    _proto.renderValue = function renderValue() {
        var amount = this.props.item.amount;
        var amountClassname = this.props.amountClassname;
        if (amountClassname) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: amountClassname,
                children: amount
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: amount
        });
    };
    _proto.render = function render() {
        if (this.props.readOnly) {
            return this.renderValue();
        } else {
            return this.renderSelect();
        }
    };
    return Amount;
}(react.Component)) || _class, _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "update", [
    lib_esm["default"],
    _dec,
    _dec1
], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _dec2 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec3 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "onChange", [
    lib_esm["default"],
    _dec2,
    _dec3
], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class)) || _class) || _class;
/* harmony default export */ var Item_Amount = ((0,refetchCart/* withRefetchCart */.BS)(Amount));

// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Item/Options/index.tsx
var Options = __webpack_require__(86176);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/index.tsx + 35 modules
var SelectProduct = __webpack_require__(34948);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Item/Update/styles.module.css
var Update_styles_module = __webpack_require__(46254);
var Update_styles_module_default = /*#__PURE__*/__webpack_require__.n(Update_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/Item/Update/index.tsx




function Update(props) {
    var item = props.item;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProduct/* default */.Z, {
                product: item.product,
                open: open,
                cartItem: item,
                close: function() {
                    return setOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Update_styles_module_default()).container,
                onClick: function() {
                    setOpen(true);
                },
                role: "button",
                "aria-label": "update_cart_item",
                id: "update_cart_item_button",
                // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; className: string; onCli... Remove this comment to see the full error message
                name: "update_cart_item_button",
                children: "Editar"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Item/styles.module.css
var Item_styles_module = __webpack_require__(79849);
var Item_styles_module_default = /*#__PURE__*/__webpack_require__.n(Item_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/Item/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

















var Item = function(props) {
    var _showOptions = props.showOptions, showOptions = _showOptions === void 0 ? true : _showOptions, _smallPadding = props.smallPadding, smallPadding = _smallPadding === void 0 ? false : _smallPadding;
    var benefits = useItemBenefits();
    var eventBaseProperties = (0,useEventsBaseProperties/* default */.Z)();
    var actionLocation = (0,useAnalyticLocation/* default */.Z)("purchaseEdit");
    var getBenefitByItem = (0,react.useMemo)(function() {
        var ref1;
        var item = props.item;
        var itemModifiers = ((ref1 = item.modifiers) === null || ref1 === void 0 ? void 0 : ref1.length) ? item.modifiers.map(function(modifier) {
            return omit_default()(modifier, [
                "__typename"
            ]);
        }) : [];
        return benefits === null || benefits === void 0 ? void 0 : benefits.find(function(param) {
            var productId = param.productId, benefitItem = param.item;
            var ref;
            return productId === (item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref._id) && isEqual_default()(itemModifiers, benefitItem.modifiers);
        });
    }, [
        props
    ]);
    var sendEditAmountEvent = function(param) {
        var amount = param.amount;
        var ref, ref2, ref3;
        var ref4;
        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.productEdited */.F.purchase.productEdited, _objectSpread({}, eventBaseProperties, {
            productEditAction: amount === 0 ? "delete" : "edit",
            productId: (ref4 = (ref = props.item) === null || ref === void 0 ? void 0 : (ref2 = ref.product) === null || ref2 === void 0 ? void 0 : ref2._id) !== null && ref4 !== void 0 ? ref4 : "",
            productAmount: amount,
            isAmountEdited: true,
            isOutOfStock: (ref3 = props.item) === null || ref3 === void 0 ? void 0 : ref3.isOutOfStock,
            menuId: props.menuId,
            actionLocation: actionLocation
        }));
    };
    var renderPrice = function() {
        var _item = props.item, unitPrice = _item.unitPrice, realPrice = _item.realPrice, amount = _item.amount;
        var benefit = getBenefitByItem;
        if (unitPrice === null) return "No disponible";
        if (realPrice === unitPrice && !benefit) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                value: unitPrice * amount
            });
        }
        if (realPrice !== unitPrice && !benefit) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Item_styles_module_default()).realPrice,
                        children: (0,formatNumber/* default */.Z)(realPrice * amount, "money")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                        value: unitPrice * amount
                    })
                ]
            });
        }
        if (benefit && (benefit === null || benefit === void 0 ? void 0 : benefit.totalPriceWithBenefit)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Item_styles_module_default()).realPrice,
                        children: (0,formatNumber/* default */.Z)(realPrice * amount, "money")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                        value: benefit === null || benefit === void 0 ? void 0 : benefit.totalPriceWithBenefit
                    })
                ]
            });
        }
    };
    var readOnly = props.readOnly, item1 = props.item, amountClassname = props.amountClassname;
    var product = item1.product, deletedAt = item1.deletedAt;
    var isLoading = item1 && item1._id && item1._id.startsWith("pending");
    var containerStyle = smallPadding ? (Item_styles_module_default()).smallPaddingContainer : (Item_styles_module_default()).container;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: isLoading ? (Item_styles_module_default()).loading : containerStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Item_styles_module_default()).head, deletedAt && (Item_styles_module_default()).deleted),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Item_styles_module_default()).amount,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item_Amount, {
                            item: props.item,
                            readOnly: readOnly,
                            amountClassname: amountClassname,
                            sendEvent: sendEditAmountEvent
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Item_styles_module_default()).name,
                        children: [
                            product.name,
                            deletedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Item_styles_module_default()).deletedAt,
                                children: props.t("fields.deleted", {
                                    ns: "generic"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Item_styles_module_default()).price,
                        children: renderPrice()
                    })
                ]
            }),
            showOptions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Item_styles_module_default()).bottom,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Options/* default */.Z, {
                        item: props.item
                    }),
                    readOnly ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Item_styles_module_default()).editContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Update, {
                            item: props.item
                        })
                    })
                ]
            }),
            item1.outOfStockMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Item_styles_module_default()).outOfStock,
                dangerouslySetInnerHTML: {
                    __html: item1.outOfStockMessage
                }
            }) : null
        ]
    });
};
/* harmony default export */ var Content_Item = ((0,esm/* withTranslation */.Zh)()(Item));


/***/ }),

/***/ 39236:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dT92xTJcgDYtuxFSbaqhS","select":"_3nUuDcybFTAS4XltiuL6eW secondaryBackgroundColor textColor backgroundBorderColor","biggerInput":"_1jrxuKMP0c7F8N0CIu8HUN secondaryBackgroundColor textColor backgroundBorderColor"};

/***/ }),

/***/ 89624:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"options":"_32bRY08lzlqG-QYO1jbGpD","selectionItems":"_2dyUQXlodwv3TOnfqaq14t","title":"_2xbpUQYuXKvzxohCKxSXkl","selectionText":"wLgQ_0QSJ8GiUAlLPqF_M"};

/***/ }),

/***/ 46254:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Ez8OKYxg3QT4lpvzL9gN_ primaryColor"};

/***/ }),

/***/ 79849:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"d7fJX35sklTYOhN7WWBya cartItem backgroundBorderColor","smallPaddingContainer":"_3ewtq4UEHqvIECPT_fd5Yx d7fJX35sklTYOhN7WWBya cartItem backgroundBorderColor","loading":"vRrzK0v9a7yClh1YWmLNt d7fJX35sklTYOhN7WWBya cartItem backgroundBorderColor","head":"_3hGmkFmt0Z6trX25FDozZe","amount":"_2m5SRnJX5XQiGq7en9ah_g","name":"_1BrY12eWvThUbhnRGlX5Gj","price":"_1-uyktyFKi94obaSE8o5mq","realPrice":"qCc6sYFpvQlb8JBRAWHHC","bottom":"_3RqeLnSNyGwUjQxFQa6FMw","options":"fXsZYY33q-MfDd7FYNDck","pos":"tX3HyZO1aqeUEDXUqQrMr","outOfStock":"_2LdnpD91zwWtTZKJfe8U89","deleted":"_2qZyeCXNCgF7Ysi_5LcfPY","deletedAt":"_1sTid_iOXfFKYvvqMdHRPk","editContainer":"_1FTya-9IejLy3mYeHzN0TX"};

/***/ })

}]);